import React, { useRef } from 'react';
import { Dropdown } from 'react-bootstrap';
import { SortingDirection } from './models/SortingDirection';
import SortingItemDescriptor from './models/SortingItemDescriptor';
import SortingMenuItem from './SortingMenuItem';
import styles from './sortingMenu.module.scss';
import { useTranslation } from 'react-i18next';

type Props = {
  id: string;
  descriptors: SortingItemDescriptor[];
  onSortingClick: (name: string, direction: SortingDirection) => void;
}

const SortingMenu = ({ id, descriptors, onSortingClick }: Props) => {
  // translations
  const tLabels = useTranslation("shared\\components").t;
  
  // ref
  const sortingMenuRef = useRef<any>();

  // sub-render
  const renderDesriptors = () => { 
    return descriptors.map((item) => 
      <SortingMenuItem 
        item={item}
        onSortingClick={onSortingClick}
        sortingMenuRef={sortingMenuRef}
        key={item.name}
      />
    );
  }

  // render
  return (
    <Dropdown ref={sortingMenuRef}>
      <Dropdown.Toggle id={id} size='sm' variant='secondary' >
        <span className="mr-1">
          {tLabels("sortingMenu.sorting")}
        </span>
      </Dropdown.Toggle>

      <Dropdown.Menu className={styles.menu}>
        {renderDesriptors()}
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default SortingMenu;